import { createSlice } from '@reduxjs/toolkit';

const INITIAL_USER_STATE = {
    profile: null,
    profileLoaded: false,
};

const userSlice = createSlice({
    name: 'user',
    initialState: INITIAL_USER_STATE,
    reducers: {
        setProfile(state, action) {
            state.profile = action.payload || null;
            state.profileLoaded = true;
        },
        clearUserState() {
            return INITIAL_USER_STATE;
        },
    },
});

export const { setProfile, clearUserState } = userSlice.actions;
export default userSlice.reducer;
